import styled from '@emotion/styled-base'
import { JumpArrowGraphic } from '../graphics'
import React, { PropsWithChildren } from 'react'
import { spacingLevel } from '../../design-system'

const LinkArrow = styled(JumpArrowGraphic)`
  vertical-align: middle;
  display: inline-block;
  margin-right: ${spacingLevel(1)}px;
`

export const JumpLink = ({ children }: PropsWithChildren<{}>) => (
  <span>
    <LinkArrow />
    {children}
  </span>
)
